<template>
    <div>
        <div>
            <v-img
                  size="80"
                  :src="profilePic"
                  style="border-radius:10%"
                  @click="openImageDialog()"
                ></v-img>
            <input
                  type="file"
                  id="files"
                  ref="fileInput"
                  :style="{display:display}"
                  accept="image/*"
                  @change="getSelectedImage"
                />
                
        </div>
    </div>

</template>

<script>
import axios from "@/plugins/axios"

    export default {
        props:{
            profilePicture:{
                default:true
            },
            imageName:{
                default:'picture'
            },
            imageFolder:{
                default:''
            },
            display:{
                default:'inline'
            },
            imagePath:{
                default:null
            }
        },
        computed:{
            getUserCompany(){
                return this.$store.getters.getUserCompany
            },
            getAccessToken(){
                return this.$store.getters.getAccessToken
            }
        },
        watch:{
            imagePath(newVal){
                this.profilePic = newVal
            }
        },
        mounted(){
            if(this.imagePath){
                this.profilePic = this.imagePath
            }
            
        },
        data: () => ({
            profilePic:"/images/products/no-photo.jpg",
            selectedImageName:'',
            
        }),
        methods:{
        
            openImageDialog() {
                document.getElementById("files").click();
            },
            getSelectedImage(event) {
            const file = event.target.files[0];
            const ext = file.type.split("/")[1];
            this.selectedImageName = this.imageName + "." + ext;
            const fileReader = new FileReader();
            fileReader.addEventListener("load", () => {
                this.profilePic = fileReader.result;
                this.$store.commit("setLoader", true);
                axios
                .postDataWithToken(
                    "/auth/upload-image",
                    {
                    image64: this.profilePic,
                    name: this.selectedImageName,
                    folder: this.imageFolder,
                    emis: this.getUserCompany.emis
                    },
                    this.getAccessToken
                )
                .then((images) => {
                    this.$emit('image-uploaded',images)
                    this.$store.commit("setLoader", false);
                    
                });
            });
            fileReader.readAsDataURL(file);
            },
        }
    }
</script>